var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report_number_card"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"report_number_card_item"},[_c('div',{staticClass:"value",style:(`color:${item.color}`)},[_vm._v(_vm._s(item.value||'-'))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }